import { useCiam } from '../providers';

export const useApi = () => {
  const { token } = useCiam();

  const getDocumentImage = (url: string) => {
    const response = fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then((data) => data.blob())
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob);
        return objectURL;
      });
    return response;
  };

  return { getDocumentImage };
};
